import { render, staticRenderFns } from "./details-field.vue?vue&type=template&id=c13c16b4&scoped=true&"
import script from "./details-field.vue?vue&type=script&lang=js&"
export * from "./details-field.vue?vue&type=script&lang=js&"
import style0 from "./details-field.vue?vue&type=style&index=0&id=c13c16b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13c16b4",
  null
  
)

export default component.exports